import React from "react";
import { Box } from "../../UI/Box";

export const TiktokIcon = () => (
  <Box component="img" width={21} height={21} src="/static/images/tiktok-icon.png" alt="snapchat" />
);
